import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

import { NewsPost } from '@features/shared/api/typings';

const TABS = [
  { value: true, label: 'Да' },
  { value: false, label: 'Нет' },
];

export function PromoInput() {
  const { control } = useFormContext<NewsPost>();

  return (
    <FormRow>
      <FormLabel>Промо</FormLabel>
      <FormInput>
        <Controller
          name="promoted"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs tabs={TABS} value={value} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
